module.exports = __webpack_public_path__ + "static/media/icon_menu_analysis.13b1b366.svg";